import { deepPurple, green } from "@mui/material/colors";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { makeModeAwareAccent } from "@entrilia/shared/utilities/colorHelper";
import type { OrganizationRole } from "../../../../api/types/userManagementTypes";
import { organizationRolesDataMap } from "./definitions";

interface Props {
  role: OrganizationRole;
}

const OrganizationRoleStatusTag = ({ role }: Props) => {
  const label = organizationRolesDataMap[role].label;
  switch (role) {
    case "Org_Owner":
      return <StatusChip label={label} color={(t) => makeModeAwareAccent(t, green)} />;
    case "Org_Member":
      return <StatusChip label={label} color={(t) => makeModeAwareAccent(t, deepPurple)} />;
    case "Org_ExternalUser":
      return <StatusChip label={label} color={(t) => t.palette.text.secondary} />;
    default:
      return null;
  }
};

export default OrganizationRoleStatusTag;
